// extracted by mini-css-extract-plugin
export default {"card":"Card_card__SsjpN","header":"Card_header__hmwEf","body":"Card_body__WsoL7","link":"Card_link__xYkOH"};